<template>
	<div class="instance-setting">
		<right-panel :datas="resourceId" ref="rightPanel" @onClose="onCloseForm" @onSubmit="onSubmitForm">
			<div slot="header">
				<translate v-if="!moreForm.moreSet">Basic information</translate>
				<translate v-if="moreForm.moreSet">Authentication settings</translate>
			</div>
			<div slot="content" class="wrapper-padding">
				<el-form ref="addForm" :model="addForm" :rules="rules" label-width="120px" v-if="!moreForm.moreSet">
					<el-form-item :label="attrText.resourceName" prop="name">
						<el-input v-model.trim="addForm.name" :disabled="parentId"></el-input>
					</el-form-item>
					<!--<el-form-item :label="attrText.instanceId">-->
					<!--<el-input v-model="addForm.instanceId" :disabled="parentId"></el-input>-->
					<!--</el-form-item>-->
					<el-form-item :label="attrText.innerIp">
						{{ addForm.ipAddress }}
					</el-form-item>
					<el-form-item :label="attrText.os">
						{{ addForm.os === 'win32' ? 'Windows' : 'Linux' }}
					</el-form-item>
					<el-form-item :label="attrText.userName">
						<el-input v-model="addForm.username" :disabled="parentId" @change="onUsername"></el-input>
						<translate>Multiple users with semicolons ‘;’</translate>
					</el-form-item>
					<el-form-item :label="attrText.port">
						<el-input v-model="addForm.port" @change="onPort" :disabled="parentId"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.flavor">
						<div class="add-textarea">
							<el-input type="textarea" v-model="addForm.flavor" :disabled="parentId"></el-input>
						</div>
					</el-form-item>
					<el-form-item :label="attrText.clipboard" v-if="addForm.os === 'win32'">
						<el-switch style="margin-right: 16px" v-model="addForm.clipboard" on-text="" off-text=""></el-switch>
					</el-form-item>
					<a class="more" @click="moreForm.moreSet = true" v-if="!parentId">
						<i class="fa fa-plus-square-o fa-lg"></i>
						<translate>More</translate>
					</a>
				</el-form>
				<!--更多设置-->
				<el-form ref="moreForm" :model="moreForm" label-width="120px" v-if="moreForm.moreSet" :show-message="false">
					<p style="margin-bottom: 10px; font-size: 16px; font-weight: bold">
						<translate>Host Authentication Mode</translate>
					</p>
					<!-- <el-form-item :label="attrText.cos">
						<el-radio class="radio" v-model="moreForm.cos" label="open">
							<translate>on</translate>
						</el-radio>
						<el-radio class="radio" v-model="moreForm.cos" label="close">
							<translate>off</translate>
						</el-radio>
						<p>
							<translate>Attention:</translate>
						</p>
						<p>
							<translate>(1)When CloudLinker permission is enabled, webssh does not support KEY authentication</translate>
						</p>
						<p>
							<translate> (2)When your CloudLinker password authentication mode is CloudLinker password, the target machine can not be authenticated by the local password </translate>
						</p>
					</el-form-item> -->
					<!-- <el-form-item :label="attrText.key">
						<el-radio class="radio" v-model="moreForm.keyVerify" label="1">
							<translate>on</translate>
						</el-radio>
						<el-radio class="radio" v-model="moreForm.keyVerify" label="0">
							<translate>off</translate>
						</el-radio>
					</el-form-item> -->
					<el-form-item>
						<el-table :data="moreForm.availability" style="width: 100%" :empty-text="attrText.emptyText">
							<el-table-column :label="attrText.accountName" show-overflow-tooltip>
								<template scope="scope">
									{{ scope.row.username }}
								</template>
							</el-table-column>
							<el-table-column :label="attrText.action">
								<template scope="scope">
									<el-button type="text" @click="onUpload({ isUpload: true, username: scope.row.username, resourceId: resourceId })"><translate>Upload</translate></el-button>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.availability">
								<template scope="scope">
									<el-button type="text" @click="onTestKeyAvaliable(scope.row)" :disabled="$store.getters.cluster.detail.info.agent && $store.getters.cluster.detail.info.agent.status !== 1">
										<translate>Test</translate>
									</el-button>
									<i class="el-icon-loading" v-if="scope.row.test_result === 'pending'"></i>
									<span v-if="scope.row.test_result === 'disable' || scope.row.test_result === 'enable'" class="badge" :class="scope.row.test_result ? (scope.row.test_result !== 'disable' ? 'available' : 'unavailable') : 'unavailable'">
										{{ scope.row.test_result ? (scope.row.test_result !== 'disable' ? attrText.available : attrText.unavailable) : attrText.unavailable }}
									</span>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.authenticationMode">
								<template scope="scope">
									<el-radio-group v-model="scope.row.auth_type">
										<el-radio :label="0"><translate>Host Password</translate></el-radio>
										<el-radio v-if="addForm.os == 'linux'" :label="1" :disabled="!scope.row.test_result || ['disable', 'pending'].includes(scope.row.test_result)">SSH KEY</el-radio>
										<el-radio v-if="addForm.os == 'win32'" :label="1" :disabled="!scope.row.test_result || ['disable', 'pending'].includes(scope.row.test_result)"><translate>Password-Free Login</translate></el-radio>
										<el-radio :label="2" :disabled="!scope.row.test_result || ['disable', 'pending'].includes(scope.row.test_result)"><translate>Team Account</translate></el-radio>
									</el-radio-group>
								</template>
							</el-table-column>
						</el-table>
						<p style="margin-top: 10px">
							<translate>Node:</translate>
						</p>
						<p>
							<translate v-if="addForm.os == 'linux'"> For SSH KEY authentication or team account authentication on the target host, ensure that the host user password has been verified. </translate>
							<translate v-if="addForm.os == 'win32'"> For password free login or team account authentication on the target host, ensure that the host user password has been verified. </translate>
						</p>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="detail-btn">
				<el-button type="primary" @click="onSubmitForm()" :disabled="!isCansubmit || parentId">
					<translate>Save</translate>
				</el-button>
				<el-button @click="onCloseForm()">
					<translate>Cancel</translate>
				</el-button>
			</div>
		</right-panel>
	</div>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
export default {
	name: 'ClusterInstanceSetting',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			resourceId: null,
			parentId: null,
			addForm: {
				name: '',
				instanceId: '',
				ipAddress: '',
				os: '',
				username: '',
				port: '',
				flavor: '',
				clipboard: true,
			},
			moreForm: {
				moreSet: false,
				cos: '',
				keyVerify: '',
				availability: [],
			},
			isCansubmit: true,
			rules: {
				name: [{ required: true, message: this.$gettext('Please input the resource name'), trigger: 'change' }],
			},
		}
	},
	computed: {
		attrText() {
			return this.translateText()
		},
	},
	created() {
		setTimeout(() => {
			this.onGetResource()
		}, 301)
	},
	methods: {
		translateText() {
			return {
				resourceName: this.$gettext('Resource name'),
				instanceId: this.$gettext('Instance ID'),
				innerIp: this.$gettext('Inner IP'),
				os: this.$gettext('OS'),
				userName: this.$gettext('Username'),
				port: this.$gettext('Port'),
				flavor: this.$gettext('Flavor Descroption'),
				cos: this.$gettext('CloudLinker Authority Authentication'),
				key: this.$gettext('Target machine key verification'),
				keyAbled: this.$gettext('The availability of key'),
				accountName: this.$gettext('Account Name'),
				availability: this.$gettext('Availability'),
				unavailable: this.$gettext('Unavailable'),
				available: this.$gettext('Available'),
				action: this.$gettext('Action'),
				clipboard: this.$gettext('Clipboard'),
				authenticationMode: this.$gettext('Authentication Mode'),
				emptyText: this.$gettext('Function update, click Save to synchronize authentication data'),
			}
		},
		onUsername(val) {
			if (val.trim()) {
				if (/^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/.test(this.addForm.port)) {
					this.isCansubmit = true
				} else {
					this.isCansubmit = false
				}
			} else {
				this.isCansubmit = false
			}
		},
		onPort(val) {
			if (/^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/.test(val)) {
				if (this.addForm.username.trim()) {
					this.isCansubmit = true
				} else {
					this.isCansubmit = false
				}
			} else {
				this.isCansubmit = false
			}
		},
		// 获取资源详情
		onGetResource() {
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_RESOURCE_DETAIL, this.resourceId).then((res) => {
				console.log(res, 'res')

				this.parentId = res.parent_id
				this.addForm = Object.assign({}, this.addForm, {
					name: res.name,
					instanceId: res.instance_id,
					ipAddress: res.ip_address,
					clipboard: res.allow_copy_paste,
					os: res.os,
					username: res.username.join(';'),
					port: res.port,
					flavor: res.flavor,
				})
				this.moreForm = Object.assign({}, this.moreForm, {
					cos: res.csos_check,
					keyVerify: res.autologin === 0 ? '0' : '1',
					availability: res.data,
				})
				console.log(this.addForm, 'addForm')
				console.log(this.moreForm, 'moreForm')
			})
		},
		// 确定修改资源
		onSubmitForm() {
			let params = {
				id: this.resourceId,
				data: {
					data: {
						os: this.addForm.os,
						username: [],
						data: this.moreForm.availability.map((item) => {
							return {
								auth_type: item.auth_type,
								username: item.username,
							}
						}),
						port: Number(this.addForm.port),
						name: this.addForm.name,
						flavor: this.addForm.flavor,
						instance_id: this.addForm.instanceId,
						ip_address: this.addForm.ipAddress,
						allow_copy_paste: this.addForm.clipboard,
						autologin: this.moreForm.keyVerify === '0' ? 0 : 1,
						csos_check: this.moreForm.cos,
					},
				},
			}
			this.addForm.username.split(';').forEach((el) => {
				if (el && el.trim()) {
					params.data.data.username.push(el.trim())
				}
			})
			if (!this.moreForm.moreSet) {
				this.$refs['addForm'].validate((valid) => {
					if (valid) {
						this.$store.dispatch(STORE_CONST.CLUSTER.PATCH_RESOURCE, params).then((res) => {
							this.$notify({
								type: 'success',
								message: this.$gettext('Change successfully!'),
							})
							this.$emit('callback')
							this.onCloseForm()
						})
					} else {
						return false
					}
				})
			} else {
				this.$store.dispatch(STORE_CONST.CLUSTER.PATCH_RESOURCE, params).then((res) => {
					this.$notify({
						type: 'success',
						message: this.$gettext('Change successfully!'),
					})
					this.$emit('callback')
					this.onCloseForm()
				})
			}
		},
		// 测试key的可用性
		onTestKeyAvaliable(list) {
			let params = {
				id: this.resourceId,
				params: {
					username: list.username,
				},
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.TEST_KEY_AVALIABLE, params).then((res) => {
				let id = res.task_id
				this.onQueryTest(list, id)
			})
		},
		// 测试key的可用性的轮询
		onQueryTest(list, id) {
			let params = {
				id: this.resourceId,
				params: {
					task_id: id,
				},
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.QUERY_KEY_AVALIABLE, params).then((res) => {
				this.$set(
					this.moreForm.availability,
					this.moreForm.availability.indexOf(list),
					Object.assign(list, {
						test_result: res.result,
					}),
				)
				if (res.result === 'pending') {
					setTimeout(() => {
						this.onQueryTest(list, id)
					}, 1000)
				} else {
					console.log('test_result', list.test_result)
				}
			})
		},
		// key 上传
		onUpload(option) {
			console.log('option', option)
			this.$emit('upload', option)
		},
		// 关闭修改集群
		onCloseForm() {
			this.connects = null
			this.$emit('onClosePanel')
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.resourceId) {
					this.resourceId = null
					setTimeout(() => {
						this.resourceId = this.items
					}, 300)
				} else {
					this.resourceId = this.items
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../../assets/css/variable';

.badge {
	padding: 2px;
	font-size: 10px;
	color: #fff;
	&.available {
		background-color: #58d99f;
	}
	&.unavailable {
		background-color: #fda541;
	}
}

.add-textarea {
	height: 110px;
	.el-textarea {
		height: 100%;
		.el-textarea__inner {
			height: 100%;
		}
	}
}

.more {
	margin-left: 20px;
	cursor: pointer;
	span {
		margin-left: 10px;
	}
	&:hover {
		color: $mainColor;
	}
}

.el-radio {
	margin: 5px 15px 5px 0;
}

.el-radio + .el-radio {
	margin-top: 0;
	margin-left: 0;
}

.el-radio__inner::after {
	width: 10px;
	height: 10px;
}

p {
	line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// cluster-instance-setting.vue?17ee3448